import type {
  TranslatePlugin,
  PluginContext,
  PageTranslateConfig,
  ParagraphTranslateConfig,
} from '../types';

export class PluginManager {
  private plugins: TranslatePlugin[] = [];
  private ctx: PluginContext | null = null;

  setContext(ctx: PluginContext): void {
    this.ctx = ctx;
  }

  register(plugin: TranslatePlugin): void {
    if (this.plugins.some(p => p.name === plugin.name)) {
      console.warn(`[PluginManager] Plugin "${plugin.name}" already registered, skipping.`);
      return;
    }
    this.plugins.push(plugin);
  }

  async initPlugin(
    pluginName: string,
    config: PageTranslateConfig | ParagraphTranslateConfig,
  ): Promise<void> {
    if (!this.ctx) {
      throw new Error('[PluginManager] Context not set. Call setContext() before initPlugin().');
    }
    const plugin = this.plugins.find(p => p.name === pluginName);
    if (!plugin) {
      throw new Error(`[PluginManager] Plugin "${pluginName}" not found.`);
    }
    await plugin.init(this.ctx, config);
  }

  getPlugin(name: string): TranslatePlugin | undefined {
    return this.plugins.find(p => p.name === name);
  }

  destroyAll(): void {
    for (const plugin of this.plugins) {
      try {
        plugin.destroy();
      } catch (e) {
        console.error(`[PluginManager] Error destroying plugin "${plugin.name}":`, e);
      }
    }
    this.plugins = [];
  }

  removeAll(): void {
    for (const plugin of this.plugins) {
      if (!plugin.remove) continue;
      try {
        plugin.remove();
      } catch (e) {
        console.error(`[PluginManager] Error removing plugin "${plugin.name}":`, e);
      }
    }
  }

  getAll(): ReadonlyArray<TranslatePlugin> {
    return this.plugins;
  }
}
